import { useMediaQuery } from '../hooks';
import Link from './Link';

function Header({ currentStreak = 0 }) {
    const isMobile = useMediaQuery('(max-width: 768px)');
    
    return (
        <header 
            className="tw-w-full tw-bg-gray-100 tw-border-b tw-border-gray-300"
            style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
        >
            <div className={`tw-max-w-[1400px] tw-mx-auto tw-px-4 tw-flex tw-items-center tw-justify-between ${isMobile ? 'tw-py-3' : 'tw-py-5'}`}>
                {/* Logo */}
                <a 
                    href="/" 
                    className="tw-flex tw-items-center tw-cursor-pointer"
                    onClick={() => sessionStorage.removeItem('was_on_habit_tracker')}
                >
                    <img 
                        src="https://cdn.shopify.com/s/files/1/0667/9599/5332/files/lexilogocolor.png?v=1767202471" 
                        alt="Lexi J Wellness"
                        style={{ height: isMobile ? '40px' : '60px' }}
                    />
                </a>
                
                {/* Streak Counter - Links to Badges page */}
                <Link href="/badges" className="tw-flex tw-items-center tw-gap-2 tw-no-underline tw-cursor-pointer">
                    <span 
                        className="tw-text-black tw-font-bold" 
                        style={{ 
                            fontFamily: 'Anton', 
                            fontSize: isMobile ? '20px' : '36px',
                            lineHeight: '1'
                        }}
                    >
                        {currentStreak}
                    </span>
                    <span style={{ fontSize: isMobile ? '20px' : '36px', lineHeight: '1' }}>🔥</span>
                </Link>
            </div>
        </header>
    );
}

export default Header;
